angular.
module("dx.webapp.lists").
component("dxSearchSortFilter", {
	templateUrl: "tmpl/lists/search-sort-filter-component.html",
	controller: angular.noop,
	controllerAs: "vm",
	bindings: {
		searchSortState: "=",
		sortOptions: "<",
		onChange: "&",
		searchPlaceholder: "<",
		dxLocalize: "<",
	},
});
